import styled from 'styled-components';

export const InputContainer = styled.div`
  input.formInput {
    display: none;
  }
`;